import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Upload } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

import { AttachmentUploadModal } from '@/features/consignment-attachment-upload';
import { useProjectSiteParams } from '@/shared/lib';

interface AttachmentsCardProps {
  consignmentId: string;
  onAttachmentUploaded?: () => void;
}

export function AttachmentsCard({ consignmentId, onAttachmentUploaded }: AttachmentsCardProps) {
  const { t } = useTranslation();
  const { projectId, siteId } = useProjectSiteParams();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium text-muted-foreground">{t('newcmr.attachments.label')}</CardTitle>
        </CardHeader>
        <CardContent>
          <Button type="button" variant="outline" onClick={() => setIsModalOpen(true)} className="w-full sm:w-auto">
            <Upload />
            {t('newcmr.add.attachment.label')}
          </Button>
        </CardContent>
      </Card>

      <AttachmentUploadModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        consignmentId={consignmentId}
        projectId={projectId}
        siteId={siteId}
        onSuccess={onAttachmentUploaded}
      />
    </>
  );
}
